import type { ComponentChildren } from "preact";

export function ModalWrapper({ children }: { children: ComponentChildren }) {
  return (
    <>
      <div class="csb-api-overlay" id="csb-api-overlay"></div>
      <div class="csb-api-modal">
        <div class="csb-api-gDXMLZ csb-api-iKKeUp">
          <div class="csb-api-gDXMLZ csb-api-bLQEZt">
            <section class="csb-api-gDXMLZ csb-api-iZHgQj csb-api-grTfzN">
              <svg
                fill="none"
                height="48"
                viewBox="0 0 16 16"
                width="48"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  clip-rule="evenodd"
                  d="M2 2L14 2V14H2V2ZM12.7727 3.22727V12.7727H3.22727V3.22727H12.7727Z"
                  fill="currentColor"
                  fill-rule="evenodd"
                ></path>
              </svg>
              {children}
            </section>
          </div>
        </div>
      </div>
    </>
  );
}
